import * as PIXI from 'pixi.js';

import { OldFilmFilter } from '@pixi/filter-old-film';
import { TiltShiftFilter } from '@pixi/filter-tilt-shift';

export default class Vol3BGAnim {
	constructor(chapter) {
		this.chapter = chapter;
		this.breakpoint = window.matchMedia('(max-width:767.5px)');
		this.init();
	}

	resize() {
		if (!this.app) {
			return;
		}

		this.app.renderer.resize(window.innerWidth, window.outerHeight);

		const canvasWidth = this.app.renderer.view.getBoundingClientRect().width;
		const canvasHeight = this.app.renderer.view.getBoundingClientRect().height;

		if (window.outerHeight > canvasWidth * 1.5) {
			this.container.width = (canvasHeight / 3) * 2;
			this.container.height = canvasHeight;
		} else {
			this.container.width = canvasWidth;
			this.container.height = canvasWidth * 1.5;
		}

		const imageHigherThanCanvas = this.container.height - canvasHeight;
		if (imageHigherThanCanvas > 0) {
			this.container.position.x = 0;
			this.container.position.y = -1 * (imageHigherThanCanvas / 2);
		}

		const imageWiderThanCanvas = this.container.width - canvasWidth;
		if (imageWiderThanCanvas > 0) {
			this.container.position.x = -1 * (imageWiderThanCanvas / 2);
			this.container.position.y = 0;
		}
	}

	init() {
		PIXI.utils.skipHello();

		this.app = new PIXI.Application({
			resolution: window.devicePixelRatio || 1,
			width: window.innerWidth,
			height: window.outerHeight,
			backgroundAlpha: 0,
		});

		this.chapter.bgWrapper.appendChild(this.app.view);

		this.container = new PIXI.Container();

		let blurmode = new PIXI.filters.BlurFilter();
		if (!this.breakpoint.matches) {
			// Desktop
			blurmode.blur = 10;
		} else {
			// Mobile
			blurmode.blur = 2;
		}

		let tiltshiftmode = new TiltShiftFilter();
		tiltshiftmode.blur = 100;
		tiltshiftmode.gradientBlur = 600;
		tiltshiftmode.start = new PIXI.Point(0, window.outerHeight / 2);
		tiltshiftmode.end = new PIXI.Point(window.innerWidth, window.outerHeight / 2);

		let oldfilmmode = new OldFilmFilter({
			sepia: 0,

			noise: 0.1,
			noiseSize: 0.6,

			scratch: 0,
			scratchDensity: 0,
			scratchWidth: 0,

			vignetting: 0,
			vignettingAlpha: 0,
			vignettingBlur: 0,
		});

		this.app.stage.filters = [blurmode, tiltshiftmode, oldfilmmode];
		this.app.stage.addChild(this.container);

		this.images = [];

		this.chapter.images.forEach((image) => {
			const id = image.getAttribute('data-bg-image');
			const src = image.getAttribute('data-src');

			const texture = PIXI.Texture.from(src);

			const bg = new PIXI.Sprite(texture);
			bg.alpha = 0;

			bg.id = id;
			this.container.addChild(bg);
		});

		setTimeout(() => {
			this.resize();
			this.chapter.resizeListener();
		}, 0);

		// Listen for animate update
		this.app.ticker.add((delta) => {
			if (!this.breakpoint.matches && !window.matchMedia('(pointer: coarse)').matches) {
				// Desktop

				const offset = ((this.container._height - window.outerHeight) / 100) * this.chapter.percentage;
				this.container.transform.position.y = (offset / 2) * -1;

				this.container.children.forEach((img) => {
					if (this.chapter.activeImage === img.id) {
						if (img.alpha < 1) {
							img.alpha += 0.025;
						} else {
							img.alpha = 1;
						}
					} else {
						if (img.alpha > 0) {
							img.alpha -= 0.025;
						} else {
							img.alpha = 0;
						}
					}
				});
			} else {
				// Mobile

				this.container.transform.position.y = 0;

				this.container.children.forEach((img) => {
					this.chapter.stories.forEach((story) => {
						const id = story.querySelector('[data-image-target]').getAttribute('data-image-target');
						if (id === img.id) {
							const alpha = story.getAttribute('data-mobile-opacity');
							img.alpha = alpha;
						}
					});
				});
			}

			this.app.stage.filters.forEach((filter) => {
				filter.seed = Math.random();
				filter.time += 0.01;
			});
		});
	}
}
